import React from 'react';
import { Button } from 'react-bootstrap';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="p-5 text-center" style={{ minHeight: '60vh' }}>
          <h1 className="h4 mb-3">Something went wrong</h1>
          <p className="text-muted mb-4">The application hit an unexpected error. You can try reloading the page.</p>
          <Button onClick={() => window.location.reload()}>Reload</Button>
        </div>
      );
    }
    return this.props.children;
  }
}
